import { LoyaltyProgram, LoyaltyResult, LoyaltyTier, useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { keyById } from '@mews/fp';
import { getCurrentEnterprise } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';

const select = (data: LoyaltyResult) => {
    const programs: Record<string, LoyaltyProgram> = keyById(data.programs);
    const tiers: Record<string, LoyaltyTier> = keyById(data.tiers);

    return { programs, rawPrograms: data.programs, rawTiers: data.tiers, tiers };
};

export const useLoyaltyProgramsGetAllQuery = () => {
    const enterprise = useCommanderSelector(getCurrentEnterprise);
    const { data } = useRepositorySuspenseQuery(
        'loyaltyPrograms',
        'getAll',
        {
            chainId: enterprise.chainId,
            extent: {
                programs: true,
                tiers: true,
            },
        },
        { select }
    );

    return data;
};
